import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@hotjar/hotsauce';

import { EventMarker } from '@hotjar/webapp/features/Playbacks/types';
import { getEventTooltip } from '../../utils/getEventTooltip';

interface Props {
  eventMarker: EventMarker;
  children: React.ReactElement;
}

export const EventBoxTooltip = ({ eventMarker, children }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tooltip
      text={getEventTooltip(eventMarker, t)}
      placement="left"
      isDisabled={eventMarker.type === 'viewport_resize'}
    >
      {children}
    </Tooltip>
  );
};
